import React from "react"
import Contact from "../shared/top/Contact"

const TopContact = () => {
  return <Contact target="sutea" tel="048-598-4075" />
}

export default TopContact
